export default "__VITE_ASSET__a190b384__"